function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _styled from "@emotion/styled/base";
var _excluded = ["error", "showCta"];
function cov_19zj5rh3yq() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/AutocompleteInput/AutocompleteInput.tsx";
  var hash = "8703f61bfa0d6b9884ce8fc986961d34d6a74079";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/AutocompleteInput/AutocompleteInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 24,
          column: 74
        }
      },
      "1": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 34,
          column: 2
        }
      },
      "2": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 74
        }
      },
      "3": {
        start: {
          line: 41,
          column: 26
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "4": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 79
        }
      },
      "5": {
        start: {
          line: 62,
          column: 24
        },
        end: {
          line: 62,
          column: 41
        }
      },
      "6": {
        start: {
          line: 63,
          column: 16
        },
        end: {
          line: 63,
          column: 70
        }
      },
      "7": {
        start: {
          line: 66,
          column: 29
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "8": {
        start: {
          line: 132,
          column: 65
        },
        end: {
          line: 152,
          column: 3
        }
      },
      "9": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 17
        }
      },
      "10": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 34
        }
      },
      "11": {
        start: {
          line: 161,
          column: 17
        },
        end: {
          line: 169,
          column: 3
        }
      },
      "12": {
        start: {
          line: 171,
          column: 49
        },
        end: {
          line: 184,
          column: 3
        }
      },
      "13": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 177,
          column: 7
        }
      },
      "14": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 178,
          column: 56
        }
      },
      "15": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 183,
          column: 5
        }
      },
      "16": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 25
        }
      },
      "17": {
        start: {
          line: 186,
          column: 46
        },
        end: {
          line: 210,
          column: 3
        }
      },
      "18": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 189,
          column: 5
        }
      },
      "19": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 13
        }
      },
      "20": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 209,
          column: 5
        }
      },
      "21": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 27
        }
      },
      "22": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 193,
          column: 57
        }
      },
      "23": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 194,
          column: 14
        }
      },
      "24": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 27
        }
      },
      "25": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 57
        }
      },
      "26": {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 198,
          column: 14
        }
      },
      "27": {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 200,
          column: 27
        }
      },
      "28": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 27
        }
      },
      "29": {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 14
        }
      },
      "30": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 27
        }
      },
      "31": {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 205,
          column: 28
        }
      },
      "32": {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 206,
          column: 14
        }
      },
      "33": {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 208,
          column: 14
        }
      },
      "34": {
        start: {
          line: 212,
          column: 25
        },
        end: {
          line: 219,
          column: 3
        }
      },
      "35": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 213,
          column: 30
        }
      },
      "36": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 218,
          column: 5
        }
      },
      "37": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 216,
          column: 63
        }
      },
      "38": {
        start: {
          line: 217,
          column: 6
        },
        end: {
          line: 217,
          column: 74
        }
      },
      "39": {
        start: {
          line: 221,
          column: 40
        },
        end: {
          line: 228,
          column: 3
        }
      },
      "40": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 222,
          column: 23
        }
      },
      "41": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 225,
          column: 5
        }
      },
      "42": {
        start: {
          line: 224,
          column: 6
        },
        end: {
          line: 224,
          column: 26
        }
      },
      "43": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 46
        }
      },
      "44": {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 227,
          column: 45
        }
      },
      "45": {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 237,
          column: 84
        }
      },
      "46": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 244,
          column: 5
        }
      },
      "47": {
        start: {
          line: 243,
          column: 6
        },
        end: {
          line: 243,
          column: 27
        }
      },
      "48": {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 251,
          column: 79
        }
      },
      "49": {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 269,
          column: 18
        }
      },
      "50": {
        start: {
          line: 270,
          column: 46
        },
        end: {
          line: 270,
          column: 56
        }
      },
      "51": {
        start: {
          line: 272,
          column: 25
        },
        end: {
          line: 274,
          column: 5
        }
      },
      "52": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 334,
          column: 6
        }
      },
      "53": {
        start: {
          line: 299,
          column: 28
        },
        end: {
          line: 299,
          column: 47
        }
      },
      "54": {
        start: {
          line: 337,
          column: 26
        },
        end: {
          line: 364,
          column: 3
        }
      },
      "55": {
        start: {
          line: 338,
          column: 57
        },
        end: {
          line: 338,
          column: 67
        }
      },
      "56": {
        start: {
          line: 339,
          column: 28
        },
        end: {
          line: 339,
          column: 38
        }
      },
      "57": {
        start: {
          line: 340,
          column: 4
        },
        end: {
          line: 363,
          column: 6
        }
      },
      "58": {
        start: {
          line: 352,
          column: 12
        },
        end: {
          line: 359,
          column: 14
        }
      },
      "59": {
        start: {
          line: 366,
          column: 24
        },
        end: {
          line: 371,
          column: 9
        }
      },
      "60": {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 371,
          column: 9
        }
      },
      "61": {
        start: {
          line: 373,
          column: 28
        },
        end: {
          line: 390,
          column: 3
        }
      },
      "62": {
        start: {
          line: 378,
          column: 8
        },
        end: {
          line: 378,
          column: 18
        }
      },
      "63": {
        start: {
          line: 379,
          column: 26
        },
        end: {
          line: 379,
          column: 36
        }
      },
      "64": {
        start: {
          line: 380,
          column: 27
        },
        end: {
          line: 380,
          column: 41
        }
      },
      "65": {
        start: {
          line: 381,
          column: 4
        },
        end: {
          line: 383,
          column: 7
        }
      },
      "66": {
        start: {
          line: 385,
          column: 4
        },
        end: {
          line: 389,
          column: 8
        }
      },
      "67": {
        start: {
          line: 394,
          column: 27
        },
        end: {
          line: 394,
          column: 67
        }
      },
      "68": {
        start: {
          line: 397,
          column: 31
        },
        end: {
          line: 397,
          column: 87
        }
      },
      "69": {
        start: {
          line: 398,
          column: 35
        },
        end: {
          line: 398,
          column: 93
        }
      },
      "70": {
        start: {
          line: 400,
          column: 4
        },
        end: {
          line: 404,
          column: 5
        }
      },
      "71": {
        start: {
          line: 401,
          column: 6
        },
        end: {
          line: 403,
          column: 9
        }
      },
      "72": {
        start: {
          line: 407,
          column: 24
        },
        end: {
          line: 412,
          column: 3
        }
      },
      "73": {
        start: {
          line: 408,
          column: 4
        },
        end: {
          line: 408,
          column: 36
        }
      },
      "74": {
        start: {
          line: 409,
          column: 4
        },
        end: {
          line: 409,
          column: 25
        }
      },
      "75": {
        start: {
          line: 410,
          column: 4
        },
        end: {
          line: 410,
          column: 23
        }
      },
      "76": {
        start: {
          line: 411,
          column: 4
        },
        end: {
          line: 411,
          column: 67
        }
      },
      "77": {
        start: {
          line: 414,
          column: 25
        },
        end: {
          line: 424,
          column: 3
        }
      },
      "78": {
        start: {
          line: 415,
          column: 39
        },
        end: {
          line: 415,
          column: 49
        }
      },
      "79": {
        start: {
          line: 416,
          column: 28
        },
        end: {
          line: 416,
          column: 38
        }
      },
      "80": {
        start: {
          line: 418,
          column: 4
        },
        end: {
          line: 421,
          column: 6
        }
      },
      "81": {
        start: {
          line: 422,
          column: 4
        },
        end: {
          line: 422,
          column: 36
        }
      },
      "82": {
        start: {
          line: 423,
          column: 4
        },
        end: {
          line: 423,
          column: 23
        }
      },
      "83": {
        start: {
          line: 426,
          column: 24
        },
        end: {
          line: 431,
          column: 3
        }
      },
      "84": {
        start: {
          line: 427,
          column: 4
        },
        end: {
          line: 430,
          column: 7
        }
      },
      "85": {
        start: {
          line: 433,
          column: 43
        },
        end: {
          line: 437,
          column: 3
        }
      },
      "86": {
        start: {
          line: 434,
          column: 33
        },
        end: {
          line: 434,
          column: 43
        }
      },
      "87": {
        start: {
          line: 435,
          column: 4
        },
        end: {
          line: 435,
          column: 79
        }
      },
      "88": {
        start: {
          line: 436,
          column: 4
        },
        end: {
          line: 436,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 74
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        },
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 79
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 14
          }
        },
        loc: {
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 41
          }
        },
        line: 62
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 70
          }
        },
        line: 63
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 3
          }
        },
        loc: {
          start: {
            line: 154,
            column: 21
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 154
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 171,
            column: 49
          },
          end: {
            line: 171,
            column: 50
          }
        },
        loc: {
          start: {
            line: 171,
            column: 60
          },
          end: {
            line: 184,
            column: 3
          }
        },
        line: 171
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 186,
            column: 46
          },
          end: {
            line: 186,
            column: 47
          }
        },
        loc: {
          start: {
            line: 186,
            column: 53
          },
          end: {
            line: 210,
            column: 3
          }
        },
        line: 186
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 212,
            column: 25
          },
          end: {
            line: 212,
            column: 26
          }
        },
        loc: {
          start: {
            line: 212,
            column: 58
          },
          end: {
            line: 219,
            column: 3
          }
        },
        line: 212
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 221,
            column: 40
          },
          end: {
            line: 221,
            column: 41
          }
        },
        loc: {
          start: {
            line: 221,
            column: 47
          },
          end: {
            line: 228,
            column: 3
          }
        },
        line: 221
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 230,
            column: 2
          },
          end: {
            line: 230,
            column: 3
          }
        },
        loc: {
          start: {
            line: 230,
            column: 64
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 230
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 247,
            column: 2
          },
          end: {
            line: 247,
            column: 3
          }
        },
        loc: {
          start: {
            line: 247,
            column: 29
          },
          end: {
            line: 252,
            column: 3
          }
        },
        line: 247
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 254,
            column: 2
          },
          end: {
            line: 254,
            column: 3
          }
        },
        loc: {
          start: {
            line: 254,
            column: 18
          },
          end: {
            line: 335,
            column: 3
          }
        },
        line: 254
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 299,
            column: 22
          },
          end: {
            line: 299,
            column: 23
          }
        },
        loc: {
          start: {
            line: 299,
            column: 28
          },
          end: {
            line: 299,
            column: 47
          }
        },
        line: 299
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 337,
            column: 26
          },
          end: {
            line: 337,
            column: 27
          }
        },
        loc: {
          start: {
            line: 337,
            column: 32
          },
          end: {
            line: 364,
            column: 3
          }
        },
        line: 337
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 351,
            column: 23
          },
          end: {
            line: 351,
            column: 24
          }
        },
        loc: {
          start: {
            line: 351,
            column: 71
          },
          end: {
            line: 360,
            column: 11
          }
        },
        line: 351
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 366,
            column: 24
          },
          end: {
            line: 366,
            column: 25
          }
        },
        loc: {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 371,
            column: 9
          }
        },
        line: 367
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 373,
            column: 28
          },
          end: {
            line: 373,
            column: 29
          }
        },
        loc: {
          start: {
            line: 373,
            column: 47
          },
          end: {
            line: 390,
            column: 3
          }
        },
        line: 373
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 392,
            column: 2
          },
          end: {
            line: 392,
            column: 3
          }
        },
        loc: {
          start: {
            line: 392,
            column: 26
          },
          end: {
            line: 405,
            column: 3
          }
        },
        line: 392
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 407,
            column: 24
          },
          end: {
            line: 407,
            column: 25
          }
        },
        loc: {
          start: {
            line: 407,
            column: 68
          },
          end: {
            line: 412,
            column: 3
          }
        },
        line: 407
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 414,
            column: 25
          },
          end: {
            line: 414,
            column: 26
          }
        },
        loc: {
          start: {
            line: 414,
            column: 65
          },
          end: {
            line: 424,
            column: 3
          }
        },
        line: 414
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 426,
            column: 24
          },
          end: {
            line: 426,
            column: 25
          }
        },
        loc: {
          start: {
            line: 426,
            column: 30
          },
          end: {
            line: 431,
            column: 3
          }
        },
        line: 426
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 433,
            column: 43
          },
          end: {
            line: 433,
            column: 44
          }
        },
        loc: {
          start: {
            line: 433,
            column: 50
          },
          end: {
            line: 437,
            column: 3
          }
        },
        line: 433
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 48
          },
          end: {
            line: 55,
            column: 74
          }
        }, {
          start: {
            line: 55,
            column: 77
          },
          end: {
            line: 55,
            column: 79
          }
        }],
        line: 55
      },
      "1": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 22
          }
        }, {
          start: {
            line: 55,
            column: 26
          },
          end: {
            line: 55,
            column: 45
          }
        }],
        line: 55
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 36
          }
        }, {
          start: {
            line: 62,
            column: 40
          },
          end: {
            line: 62,
            column: 41
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 50
          },
          end: {
            line: 63,
            column: 63
          }
        }, {
          start: {
            line: 63,
            column: 66
          },
          end: {
            line: 63,
            column: 70
          }
        }],
        line: 63
      },
      "4": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "5": {
        loc: {
          start: {
            line: 187,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 187,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 187
      },
      "6": {
        loc: {
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 187,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 187,
            column: 16
          }
        }, {
          start: {
            line: 187,
            column: 20
          },
          end: {
            line: 187,
            column: 29
          }
        }, {
          start: {
            line: 187,
            column: 33
          },
          end: {
            line: 187,
            column: 43
          }
        }, {
          start: {
            line: 187,
            column: 47
          },
          end: {
            line: 187,
            column: 56
          }
        }],
        line: 187
      },
      "7": {
        loc: {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 194,
            column: 14
          }
        }, {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 198,
            column: 14
          }
        }, {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 202,
            column: 14
          }
        }, {
          start: {
            line: 203,
            column: 6
          },
          end: {
            line: 206,
            column: 14
          }
        }, {
          start: {
            line: 207,
            column: 6
          },
          end: {
            line: 208,
            column: 14
          }
        }],
        line: 190
      },
      "8": {
        loc: {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 215
      },
      "9": {
        loc: {
          start: {
            line: 217,
            column: 31
          },
          end: {
            line: 217,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 217,
            column: 31
          },
          end: {
            line: 217,
            column: 50
          }
        }, {
          start: {
            line: 217,
            column: 54
          },
          end: {
            line: 217,
            column: 66
          }
        }],
        line: 217
      },
      "10": {
        loc: {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 225,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 225,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 223
      },
      "11": {
        loc: {
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 223,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 223,
            column: 24
          }
        }, {
          start: {
            line: 223,
            column: 28
          },
          end: {
            line: 223,
            column: 47
          }
        }, {
          start: {
            line: 223,
            column: 51
          },
          end: {
            line: 223,
            column: 88
          }
        }],
        line: 223
      },
      "12": {
        loc: {
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 226,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 226,
            column: 21
          }
        }, {
          start: {
            line: 226,
            column: 25
          },
          end: {
            line: 226,
            column: 45
          }
        }],
        line: 226
      },
      "13": {
        loc: {
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 237,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 236,
            column: 36
          }
        }, {
          start: {
            line: 237,
            column: 7
          },
          end: {
            line: 237,
            column: 23
          }
        }, {
          start: {
            line: 237,
            column: 27
          },
          end: {
            line: 237,
            column: 83
          }
        }],
        line: 236
      },
      "14": {
        loc: {
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 238
      },
      "15": {
        loc: {
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 239,
            column: 22
          }
        }, {
          start: {
            line: 240,
            column: 7
          },
          end: {
            line: 240,
            column: 47
          }
        }, {
          start: {
            line: 240,
            column: 51
          },
          end: {
            line: 240,
            column: 69
          }
        }, {
          start: {
            line: 241,
            column: 6
          },
          end: {
            line: 241,
            column: 49
          }
        }],
        line: 239
      },
      "16": {
        loc: {
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 273,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 273,
            column: 11
          }
        }, {
          start: {
            line: 273,
            column: 16
          },
          end: {
            line: 273,
            column: 32
          }
        }, {
          start: {
            line: 273,
            column: 36
          },
          end: {
            line: 273,
            column: 43
          }
        }, {
          start: {
            line: 273,
            column: 49
          },
          end: {
            line: 273,
            column: 72
          }
        }, {
          start: {
            line: 273,
            column: 76
          },
          end: {
            line: 273,
            column: 87
          }
        }],
        line: 273
      },
      "17": {
        loc: {
          start: {
            line: 280,
            column: 15
          },
          end: {
            line: 280,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 280,
            column: 43
          },
          end: {
            line: 280,
            column: 49
          }
        }, {
          start: {
            line: 280,
            column: 52
          },
          end: {
            line: 280,
            column: 58
          }
        }],
        line: 280
      },
      "18": {
        loc: {
          start: {
            line: 281,
            column: 22
          },
          end: {
            line: 281,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 22
          },
          end: {
            line: 281,
            column: 44
          }
        }, {
          start: {
            line: 281,
            column: 48
          },
          end: {
            line: 281,
            column: 63
          }
        }],
        line: 281
      },
      "19": {
        loc: {
          start: {
            line: 287,
            column: 9
          },
          end: {
            line: 330,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 288,
            column: 10
          },
          end: {
            line: 308,
            column: 12
          }
        }, {
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 329,
            column: 20
          }
        }],
        line: 287
      },
      "20": {
        loc: {
          start: {
            line: 304,
            column: 25
          },
          end: {
            line: 304,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 25
          },
          end: {
            line: 304,
            column: 47
          }
        }, {
          start: {
            line: 304,
            column: 51
          },
          end: {
            line: 304,
            column: 66
          }
        }],
        line: 304
      },
      "21": {
        loc: {
          start: {
            line: 331,
            column: 9
          },
          end: {
            line: 331,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 9
          },
          end: {
            line: 331,
            column: 22
          }
        }, {
          start: {
            line: 331,
            column: 26
          },
          end: {
            line: 331,
            column: 38
          }
        }, {
          start: {
            line: 331,
            column: 42
          },
          end: {
            line: 331,
            column: 60
          }
        }, {
          start: {
            line: 331,
            column: 64
          },
          end: {
            line: 331,
            column: 84
          }
        }],
        line: 331
      },
      "22": {
        loc: {
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 332,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 332,
            column: 21
          }
        }, {
          start: {
            line: 332,
            column: 25
          },
          end: {
            line: 332,
            column: 43
          }
        }],
        line: 332
      },
      "23": {
        loc: {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 371,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 368,
            column: 8
          },
          end: {
            line: 368,
            column: 32
          }
        }, {
          start: {
            line: 369,
            column: 8
          },
          end: {
            line: 371,
            column: 9
          }
        }],
        line: 367
      },
      "24": {
        loc: {
          start: {
            line: 369,
            column: 8
          },
          end: {
            line: 371,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 369,
            column: 8
          },
          end: {
            line: 369,
            column: 42
          }
        }, {
          start: {
            line: 370,
            column: 10
          },
          end: {
            line: 370,
            column: 70
          }
        }],
        line: 369
      },
      "25": {
        loc: {
          start: {
            line: 382,
            column: 19
          },
          end: {
            line: 382,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 382,
            column: 36
          },
          end: {
            line: 382,
            column: 41
          }
        }, {
          start: {
            line: 382,
            column: 44
          },
          end: {
            line: 382,
            column: 46
          }
        }],
        line: 382
      },
      "26": {
        loc: {
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 389,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 29
          }
        }, {
          start: {
            line: 386,
            column: 6
          },
          end: {
            line: 389,
            column: 7
          }
        }],
        line: 385
      },
      "27": {
        loc: {
          start: {
            line: 387,
            column: 8
          },
          end: {
            line: 387,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 76
          }
        }, {
          start: {
            line: 387,
            column: 79
          },
          end: {
            line: 387,
            column: 88
          }
        }],
        line: 387
      },
      "28": {
        loc: {
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 52
          }
        }, {
          start: {
            line: 387,
            column: 56
          },
          end: {
            line: 387,
            column: 76
          }
        }],
        line: 387
      },
      "29": {
        loc: {
          start: {
            line: 394,
            column: 27
          },
          end: {
            line: 394,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 394,
            column: 27
          },
          end: {
            line: 394,
            column: 46
          }
        }, {
          start: {
            line: 394,
            column: 50
          },
          end: {
            line: 394,
            column: 67
          }
        }],
        line: 394
      },
      "30": {
        loc: {
          start: {
            line: 397,
            column: 31
          },
          end: {
            line: 397,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 397,
            column: 31
          },
          end: {
            line: 397,
            column: 58
          }
        }, {
          start: {
            line: 397,
            column: 62
          },
          end: {
            line: 397,
            column: 87
          }
        }],
        line: 397
      },
      "31": {
        loc: {
          start: {
            line: 398,
            column: 35
          },
          end: {
            line: 398,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 398,
            column: 35
          },
          end: {
            line: 398,
            column: 63
          }
        }, {
          start: {
            line: 398,
            column: 67
          },
          end: {
            line: 398,
            column: 93
          }
        }],
        line: 398
      },
      "32": {
        loc: {
          start: {
            line: 400,
            column: 4
          },
          end: {
            line: 404,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 400,
            column: 4
          },
          end: {
            line: 404,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 400
      },
      "33": {
        loc: {
          start: {
            line: 400,
            column: 8
          },
          end: {
            line: 400,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 400,
            column: 8
          },
          end: {
            line: 400,
            column: 26
          }
        }, {
          start: {
            line: 400,
            column: 31
          },
          end: {
            line: 400,
            column: 53
          }
        }, {
          start: {
            line: 400,
            column: 57
          },
          end: {
            line: 400,
            column: 71
          }
        }],
        line: 400
      },
      "34": {
        loc: {
          start: {
            line: 402,
            column: 26
          },
          end: {
            line: 402,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 402,
            column: 54
          },
          end: {
            line: 402,
            column: 59
          }
        }, {
          start: {
            line: 402,
            column: 62
          },
          end: {
            line: 402,
            column: 66
          }
        }],
        line: 402
      },
      "35": {
        loc: {
          start: {
            line: 411,
            column: 4
          },
          end: {
            line: 411,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 411,
            column: 4
          },
          end: {
            line: 411,
            column: 32
          }
        }, {
          start: {
            line: 411,
            column: 36
          },
          end: {
            line: 411,
            column: 66
          }
        }],
        line: 411
      },
      "36": {
        loc: {
          start: {
            line: 414,
            column: 26
          },
          end: {
            line: 414,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 414,
            column: 56
          },
          end: {
            line: 414,
            column: 60
          }
        }],
        line: 414
      },
      "37": {
        loc: {
          start: {
            line: 419,
            column: 6
          },
          end: {
            line: 419,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 419,
            column: 6
          },
          end: {
            line: 419,
            column: 12
          }
        }, {
          start: {
            line: 419,
            column: 16
          },
          end: {
            line: 419,
            column: 36
          }
        }, {
          start: {
            line: 419,
            column: 41
          },
          end: {
            line: 419,
            column: 87
          }
        }],
        line: 419
      },
      "38": {
        loc: {
          start: {
            line: 436,
            column: 4
          },
          end: {
            line: 436,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 436,
            column: 4
          },
          end: {
            line: 436,
            column: 11
          }
        }, {
          start: {
            line: 436,
            column: 15
          },
          end: {
            line: 436,
            column: 25
          }
        }],
        line: 436
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0],
      "37": [0, 0, 0],
      "38": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8703f61bfa0d6b9884ce8fc986961d34d6a74079"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19zj5rh3yq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19zj5rh3yq();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */
import React, { createRef } from 'react';
import { forwardRef } from '@chakra-ui/system';
import { css, jsx } from '@emotion/react';
import { Box, Flex } from "../../core/index.mjs";
import { InputBase } from "../../core/Input/index.mjs";
import { colors } from "../../theme/eero/index.mjs";
import { screenReaderOnly } from "../../utils/ScreenReaderOnly.mjs";
import { CtaInputLite } from "../CtaInput/index.mjs";
import { InputWrapper, Wrapper } from "../CtaInput/shared.mjs";
import { ErrorPrompt } from "../ErrorPrompt/index.mjs";
import { AutocompleteOption } from "./AutocompleteOption.mjs";
var KEYS = (cov_19zj5rh3yq().s[0]++, {
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  enter: 13,
  esc: 27
});
var AutocompleteInputWrapper = (cov_19zj5rh3yq().s[1]++, forwardRef(function (_ref, ref) {
  var error = _ref.error,
    showCta = _ref.showCta,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_19zj5rh3yq().f[0]++;
  cov_19zj5rh3yq().s[2]++;
  return jsx(Flex, _extends({
    flexDirection: "column",
    position: "relative",
    ref: ref
  }, props));
}));
export var ResultList = (cov_19zj5rh3yq().s[3]++, /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1f034sk0"
} : {
  target: "e1f034sk0",
  label: "ResultList"
})("margin:0;list-style:none;padding-left:0;position:absolute;box-sizing:border-box;width:100%;margin-top:-4px;bottom:", function (props) {
  cov_19zj5rh3yq().f[1]++;
  cov_19zj5rh3yq().s[4]++;
  return (cov_19zj5rh3yq().b[1][0]++, props.displayAbove) && (cov_19zj5rh3yq().b[1][1]++, props.wrapperHeight) ? (cov_19zj5rh3yq().b[0][0]++, props.wrapperHeight + 'px') : (cov_19zj5rh3yq().b[0][1]++, '');
}, ";text-align:left;background-color:#fff;border:1px solid ", colors.neutrals10, ";border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top:none;z-index:", function (props) {
  cov_19zj5rh3yq().f[2]++;
  cov_19zj5rh3yq().s[5]++;
  return (cov_19zj5rh3yq().b[2][0]++, props.zIndex) || (cov_19zj5rh3yq().b[2][1]++, 2);
}, ";", function (props) {
  cov_19zj5rh3yq().f[3]++;
  cov_19zj5rh3yq().s[6]++;
  return props.designStyle === 'rounded' ? (cov_19zj5rh3yq().b[3][0]++, RoundedStyles) : (cov_19zj5rh3yq().b[3][1]++, null);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
export var RoundedStyles = (cov_19zj5rh3yq().s[7]++, process.env.NODE_ENV === "production" ? {
  name: "59siwz",
  styles: "transform-origin:center top!important;transform:scale(0.89)!important;border-bottom-left-radius:20px;border-bottom-right-radius:20px"
} : {
  name: "1bro3ht-RoundedStyles",
  styles: "transform-origin:center top!important;transform:scale(0.89)!important;border-bottom-left-radius:20px;border-bottom-right-radius:20px;label:RoundedStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var AutocompleteInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AutocompleteInput, _React$PureComponent);
  function AutocompleteInput(props) {
    var _this;
    _classCallCheck(this, AutocompleteInput);
    cov_19zj5rh3yq().f[4]++;
    cov_19zj5rh3yq().s[9]++;
    _this = _callSuper(this, AutocompleteInput, [props]);

    // Use this ref to keep track of the height of the wrapper
    _defineProperty(_assertThisInitialized(_this), "wrapperRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", (cov_19zj5rh3yq().s[11]++, {
      activeIndex: -1,
      dirty: false,
      hideOptions: true,
      invalidUserInput: false,
      isInputFocused: false,
      userInput: undefined,
      wrapperHeight: 0
    }));
    _defineProperty(_assertThisInitialized(_this), "onQueryChange", (cov_19zj5rh3yq().s[12]++, function (event) {
      cov_19zj5rh3yq().f[5]++;
      cov_19zj5rh3yq().s[13]++;
      _this.setState({
        dirty: true,
        hideOptions: false,
        userInput: event.target.value,
        invalidUserInput: false
      });
      cov_19zj5rh3yq().s[14]++;
      _this.props.onInputChange(event.target.value, false);

      //hide options dropdown when we have no query
      cov_19zj5rh3yq().s[15]++;
      if (!event.target.value) {
        cov_19zj5rh3yq().b[4][0]++;
        cov_19zj5rh3yq().s[16]++;
        _this.hideOptions();
      } else {
        cov_19zj5rh3yq().b[4][1]++;
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", (cov_19zj5rh3yq().s[17]++, function (e) {
      cov_19zj5rh3yq().f[6]++;
      cov_19zj5rh3yq().s[18]++;
      if ((cov_19zj5rh3yq().b[6][0]++, e.altKey) || (cov_19zj5rh3yq().b[6][1]++, e.ctrlKey) || (cov_19zj5rh3yq().b[6][2]++, e.shiftKey) || (cov_19zj5rh3yq().b[6][3]++, e.metaKey)) {
        cov_19zj5rh3yq().b[5][0]++;
        cov_19zj5rh3yq().s[19]++;
        return;
      } else {
        cov_19zj5rh3yq().b[5][1]++;
      }
      cov_19zj5rh3yq().s[20]++;
      switch (e.keyCode) {
        case KEYS.down:
          cov_19zj5rh3yq().b[7][0]++;
          cov_19zj5rh3yq().s[21]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[22]++;
          _this.makeActiveIndex(_this.state.activeIndex + 1);
          cov_19zj5rh3yq().s[23]++;
          break;
        case KEYS.up:
          cov_19zj5rh3yq().b[7][1]++;
          cov_19zj5rh3yq().s[24]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[25]++;
          _this.makeActiveIndex(_this.state.activeIndex - 1);
          cov_19zj5rh3yq().s[26]++;
          break;
        case KEYS.esc:
          cov_19zj5rh3yq().b[7][2]++;
          cov_19zj5rh3yq().s[27]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[28]++;
          _this.hideOptions();
          cov_19zj5rh3yq().s[29]++;
          break;
        case KEYS.enter:
          cov_19zj5rh3yq().b[7][3]++;
          cov_19zj5rh3yq().s[30]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[31]++;
          _this.selectOption();
          cov_19zj5rh3yq().s[32]++;
          break;
        default:
          cov_19zj5rh3yq().b[7][4]++;
          cov_19zj5rh3yq().s[33]++;
          break;
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "onOptionClick", (cov_19zj5rh3yq().s[34]++, function (option) {
      cov_19zj5rh3yq().f[7]++;
      cov_19zj5rh3yq().s[35]++;
      _this.selectOption(option);
      cov_19zj5rh3yq().s[36]++;
      if (_this.props.shouldReplaceInputOnSelect) {
        cov_19zj5rh3yq().b[8][0]++;
        cov_19zj5rh3yq().s[37]++;
        _this.setState({
          dirty: false,
          invalidUserInput: false
        });
        cov_19zj5rh3yq().s[38]++;
        _this.props.onInputChange((cov_19zj5rh3yq().b[9][0]++, option.displayValue) || (cov_19zj5rh3yq().b[9][1]++, option.value), true);
      } else {
        cov_19zj5rh3yq().b[8][1]++;
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "onBlur", (cov_19zj5rh3yq().s[39]++, function (e) {
      cov_19zj5rh3yq().f[8]++;
      cov_19zj5rh3yq().s[40]++;
      _this.hideOptions();
      cov_19zj5rh3yq().s[41]++;
      if ((cov_19zj5rh3yq().b[11][0]++, _this.state.dirty) && (cov_19zj5rh3yq().b[11][1]++, !_this.props.showCta) && (cov_19zj5rh3yq().b[11][2]++, _this.props.shouldReplaceInputOnSelect)) {
        cov_19zj5rh3yq().b[10][0]++;
        cov_19zj5rh3yq().s[42]++;
        _this.selectOption();
      } else {
        cov_19zj5rh3yq().b[10][1]++;
      }
      cov_19zj5rh3yq().s[43]++;
      (cov_19zj5rh3yq().b[12][0]++, _this.props.onBlur) && (cov_19zj5rh3yq().b[12][1]++, _this.props.onBlur(e));
      cov_19zj5rh3yq().s[44]++;
      _this.setState({
        isInputFocused: false
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "renderOptions", (cov_19zj5rh3yq().s[54]++, function () {
      cov_19zj5rh3yq().f[13]++;
      var _ref2 = (cov_19zj5rh3yq().s[55]++, _this.props),
        inputProps = _ref2.inputProps,
        options = _ref2.options,
        optionsDisplayProps = _ref2.optionsDisplayProps;
      var _ref3 = (cov_19zj5rh3yq().s[56]++, _this.state),
        activeIndex = _ref3.activeIndex;
      cov_19zj5rh3yq().s[57]++;
      return jsx(Box, null, jsx(ResultList, {
        id: "autocomplete-options",
        designStyle: inputProps.designStyle,
        zIndex: optionsDisplayProps === null || optionsDisplayProps === void 0 ? void 0 : optionsDisplayProps.zIndex,
        displayAbove: optionsDisplayProps === null || optionsDisplayProps === void 0 ? void 0 : optionsDisplayProps.displayAbove,
        className: "autocomplete-options result-list",
        role: "listbox",
        wrapperHeight: _this.state.wrapperHeight
      }, options.map(function (option, index) {
        cov_19zj5rh3yq().f[14]++;
        cov_19zj5rh3yq().s[58]++;
        return jsx(AutocompleteOption, {
          option: option,
          key: index,
          selected: index === activeIndex,
          onClick: _this.onOptionClick
        });
      })));
    }));
    _defineProperty(_assertThisInitialized(_this), "renderError", (cov_19zj5rh3yq().s[59]++, function () {
      cov_19zj5rh3yq().f[15]++;
      cov_19zj5rh3yq().s[60]++;
      return _this.props.renderError ? (cov_19zj5rh3yq().b[23][0]++, _this.props.renderError()) : (cov_19zj5rh3yq().b[23][1]++, (cov_19zj5rh3yq().b[24][0]++, _this.props.invalidUserInputMessage) && (cov_19zj5rh3yq().b[24][1]++, jsx(ErrorPrompt, {
        message: _this.props.invalidUserInputMessage
      })));
    }));
    _defineProperty(_assertThisInitialized(_this), "makeActiveIndex", (cov_19zj5rh3yq().s[61]++, function (index) {
      cov_19zj5rh3yq().f[16]++;
      var _ref4 = (cov_19zj5rh3yq().s[62]++, _this.props),
        options = _ref4.options,
        onInputChange = _ref4.onInputChange,
        shouldReplaceInputOnClick = _ref4.shouldReplaceInputOnSelect;
      var _ref5 = (cov_19zj5rh3yq().s[63]++, _this.state),
        userInput = _ref5.userInput;
      var selectedOption = (cov_19zj5rh3yq().s[64]++, options[index]);
      cov_19zj5rh3yq().s[65]++;
      _this.setState({
        activeIndex: selectedOption ? (cov_19zj5rh3yq().b[25][0]++, index) : (cov_19zj5rh3yq().b[25][1]++, -1)
      });
      cov_19zj5rh3yq().s[66]++;
      (cov_19zj5rh3yq().b[26][0]++, shouldReplaceInputOnClick) && (cov_19zj5rh3yq().b[26][1]++, onInputChange(selectedOption ? (cov_19zj5rh3yq().b[27][0]++, (cov_19zj5rh3yq().b[28][0]++, selectedOption.displayValue) || (cov_19zj5rh3yq().b[28][1]++, selectedOption.value)) : (cov_19zj5rh3yq().b[27][1]++, userInput), true));
    }));
    _defineProperty(_assertThisInitialized(_this), "handleClick", (cov_19zj5rh3yq().s[72]++, function (e) {
      cov_19zj5rh3yq().f[18]++;
      cov_19zj5rh3yq().s[73]++;
      _this.setState({
        dirty: false
      });
      cov_19zj5rh3yq().s[74]++;
      _this.validateInput();
      cov_19zj5rh3yq().s[75]++;
      _this.hideOptions();
      cov_19zj5rh3yq().s[76]++;
      (cov_19zj5rh3yq().b[35][0]++, !_this.state.invalidUserInput) && (cov_19zj5rh3yq().b[35][1]++, _this.props.ctaProps.onClick(e));
    }));
    _defineProperty(_assertThisInitialized(_this), "selectOption", (cov_19zj5rh3yq().s[77]++, function () {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_19zj5rh3yq().b[36][0]++, null);
      cov_19zj5rh3yq().f[19]++;
      var _ref6 = (cov_19zj5rh3yq().s[78]++, _this.props),
        options = _ref6.options,
        select = _ref6.select,
        input = _ref6.input;
      var _ref7 = (cov_19zj5rh3yq().s[79]++, _this.state),
        activeIndex = _ref7.activeIndex;
      cov_19zj5rh3yq().s[80]++;
      select((cov_19zj5rh3yq().b[37][0]++, option) || (cov_19zj5rh3yq().b[37][1]++, options[activeIndex]) || (cov_19zj5rh3yq().b[37][2]++, {
        displayValue: input
      }), activeIndex);
      cov_19zj5rh3yq().s[81]++;
      _this.setState({
        dirty: false
      });
      cov_19zj5rh3yq().s[82]++;
      _this.hideOptions();
    }));
    _defineProperty(_assertThisInitialized(_this), "hideOptions", (cov_19zj5rh3yq().s[83]++, function () {
      cov_19zj5rh3yq().f[20]++;
      cov_19zj5rh3yq().s[84]++;
      _this.setState({
        activeIndex: -1,
        hideOptions: true
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "onFocus", (cov_19zj5rh3yq().s[85]++, function (e) {
      cov_19zj5rh3yq().f[21]++;
      var _ref8 = (cov_19zj5rh3yq().s[86]++, _this.props),
        onFocus = _ref8.onFocus,
        options = _ref8.options;
      cov_19zj5rh3yq().s[87]++;
      _this.setState({
        isInputFocused: true,
        hideOptions: options.length === 0
      });
      cov_19zj5rh3yq().s[88]++;
      (cov_19zj5rh3yq().b[38][0]++, onFocus) && (cov_19zj5rh3yq().b[38][1]++, onFocus(e));
    }));
    cov_19zj5rh3yq().s[10]++;
    _this.wrapperRef = /*#__PURE__*/createRef();
    return _this;
  }
  _createClass(AutocompleteInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_19zj5rh3yq().f[9]++;
      // Don't want to trigger a re-render if props have not changed
      // However, there is an exception when the first query that the user enters
      // also results in a empty list
      // if validationThreshold reached or no validationThreshold
      var noValidationThresholdOrGreaterThanThreshold = (cov_19zj5rh3yq().s[45]++, (cov_19zj5rh3yq().b[13][0]++, !prevProps.validationThreshold) || (cov_19zj5rh3yq().b[13][1]++, this.props.input) && (cov_19zj5rh3yq().b[13][2]++, this.props.input.length >= prevProps.validationThreshold));
      cov_19zj5rh3yq().s[46]++;
      if ((cov_19zj5rh3yq().b[15][0]++, this.props.input) && ((cov_19zj5rh3yq().b[15][1]++, !this.props.fetchOptionsStatus.isLoading) || (cov_19zj5rh3yq().b[15][2]++, this.props.showCta)) && (cov_19zj5rh3yq().b[15][3]++, noValidationThresholdOrGreaterThanThreshold)) {
        cov_19zj5rh3yq().b[14][0]++;
        cov_19zj5rh3yq().s[47]++;
        this.validateInput();
      } else {
        cov_19zj5rh3yq().b[14][1]++;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_19zj5rh3yq().f[10]++;
      cov_19zj5rh3yq().s[48]++;
      // set the height of the wrapper on component mount
      // This height is primarily when we want to display results above
      // The + 5 is to add some gap between the input and the result box
      this.setState({
        wrapperHeight: this.wrapperRef.current.clientHeight + 5
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _ref11,
        _this2 = this,
        _ref12,
        _options$this$state$a,
        _options$this$state$a2;
      cov_19zj5rh3yq().f[11]++;
      var _ref9 = (cov_19zj5rh3yq().s[49]++, this.props),
        ariaLabel = _ref9.ariaLabel,
        ariaLabelledby = _ref9.ariaLabelledby,
        analyticsName = _ref9.analyticsName,
        name = _ref9.name,
        inputProps = _ref9.inputProps,
        ctaProps = _ref9.ctaProps,
        showCta = _ref9.showCta,
        input = _ref9.input,
        invalidUserInputMessage = _ref9.invalidUserInputMessage,
        options = _ref9.options,
        placeholderText = _ref9.placeholderText,
        renderError = _ref9.renderError,
        failure = _ref9.failure;
      var _ref10 = (cov_19zj5rh3yq().s[50]++, this.state),
        hideOptions = _ref10.hideOptions,
        invalidUserInput = _ref10.invalidUserInput;
      var showErrorMsg = (cov_19zj5rh3yq().s[51]++, Boolean((cov_19zj5rh3yq().b[16][0]++, input) && ((cov_19zj5rh3yq().b[16][1]++, invalidUserInput) || (cov_19zj5rh3yq().b[16][2]++, failure)) && ((cov_19zj5rh3yq().b[16][3]++, invalidUserInputMessage) || (cov_19zj5rh3yq().b[16][4]++, renderError))));
      cov_19zj5rh3yq().s[52]++;
      return jsx(AutocompleteInputWrapper, {
        error: showErrorMsg,
        showCta: showCta,
        width: inputProps.unboundedWidth ? (cov_19zj5rh3yq().b[17][0]++, '100%') : (cov_19zj5rh3yq().b[17][1]++, 'auto'),
        borderRadius: (_ref11 = (cov_19zj5rh3yq().b[18][0]++, inputProps.designStyle)) !== null && _ref11 !== void 0 ? _ref11 : (cov_19zj5rh3yq().b[18][1]++, 'roundedSquare'),
        ref: this.wrapperRef
      }, jsx(Box, {
        as: "span",
        sx: screenReaderOnly,
        "aria-live": "assertive"
      }, options.length), showCta ? (cov_19zj5rh3yq().b[19][0]++, jsx(CtaInputLite, _extends({
        analyticsName: analyticsName,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        inputType: "text",
        value: input,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onChange: this.onQueryChange,
        onKeyDown: this.onKeyDown,
        placeholderText: placeholderText,
        onSubmit: function onSubmit() {
          cov_19zj5rh3yq().f[12]++;
          cov_19zj5rh3yq().s[53]++;
          return _this2.selectOption();
        },
        failure: showErrorMsg,
        unboundedWidth: showCta // can be overridden by inputProps
        ,
        autoComplete: "off",
        ctaProps: _objectSpread(_objectSpread({}, ctaProps), {}, {
          onClick: this.handleClick
        }),
        designStyle: (_ref12 = (cov_19zj5rh3yq().b[20][0]++, inputProps.designStyle)) !== null && _ref12 !== void 0 ? _ref12 : (cov_19zj5rh3yq().b[20][1]++, 'roundedSquare'),
        "aria-expanded": options.length > 0,
        "aria-activedescendant": "".concat((_options$this$state$a = options[this.state.activeIndex]) === null || _options$this$state$a === void 0 ? void 0 : _options$this$state$a.value, "-option")
      }, inputProps))) : (cov_19zj5rh3yq().b[19][1]++, jsx(Wrapper, _extends({
        className: "od-autocomplete-wrapper"
      }, inputProps, {
        failure: showErrorMsg
      }), jsx(InputWrapper, null, jsx(InputBase, _extends({
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        name: name,
        type: "text",
        value: input,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onChange: this.onQueryChange,
        onKeyDown: this.onKeyDown,
        unboundedWidth: showCta // can be overridden by inputProps
        ,
        autoComplete: "off",
        "aria-expanded": options.length > 0,
        "aria-activedescendant": "".concat((_options$this$state$a2 = options[this.state.activeIndex]) === null || _options$this$state$a2 === void 0 ? void 0 : _options$this$state$a2.value, "-option")
      }, inputProps))))), (cov_19zj5rh3yq().b[21][0]++, !showErrorMsg) && (cov_19zj5rh3yq().b[21][1]++, !hideOptions) && (cov_19zj5rh3yq().b[21][2]++, options.length > 0) && (cov_19zj5rh3yq().b[21][3]++, this.renderOptions()), (cov_19zj5rh3yq().b[22][0]++, showErrorMsg) && (cov_19zj5rh3yq().b[22][1]++, this.renderError()));
    }
  }, {
    key: "validateInput",
    value: function validateInput() {
      cov_19zj5rh3yq().f[17]++;
      // Always validate for autompletion without a CTA button OR if the input has been submitted
      var shouldValidate = (cov_19zj5rh3yq().s[67]++, (cov_19zj5rh3yq().b[29][0]++, !this.props.showCta) || (cov_19zj5rh3yq().b[29][1]++, !this.state.dirty));

      // validate input once user starts typing
      var isInvalidAndTyping = (cov_19zj5rh3yq().s[68]++, (cov_19zj5rh3yq().b[30][0]++, this.state.invalidUserInput) && (cov_19zj5rh3yq().b[30][1]++, this.props.options.length));
      var isNotInvalidAndDeleted = (cov_19zj5rh3yq().s[69]++, (cov_19zj5rh3yq().b[31][0]++, !this.state.invalidUserInput) && (cov_19zj5rh3yq().b[31][1]++, !this.props.options.length));
      cov_19zj5rh3yq().s[70]++;
      if ((cov_19zj5rh3yq().b[33][0]++, isInvalidAndTyping) || (cov_19zj5rh3yq().b[33][1]++, isNotInvalidAndDeleted) && (cov_19zj5rh3yq().b[33][2]++, shouldValidate)) {
        cov_19zj5rh3yq().b[32][0]++;
        cov_19zj5rh3yq().s[71]++;
        this.setState({
          invalidUserInput: this.props.options.length ? (cov_19zj5rh3yq().b[34][0]++, false) : (cov_19zj5rh3yq().b[34][1]++, true)
        });
      } else {
        cov_19zj5rh3yq().b[32][1]++;
      }
    }
  }]);
  return AutocompleteInput;
}((React.PureComponent));
_defineProperty(AutocompleteInput, "defaultProps", (cov_19zj5rh3yq().s[8]++, {
  input: '',
  invalidUserInputMessage: '',
  name: 'AutocompleteInput',
  placeholderText: 'Start typing...',
  showCta: false,
  shouldReplaceInputOnSelect: true,
  fetchOptionsStatus: {
    isLoading: false
  },
  inputProps: {
    designStyle: 'roundedSquare',
    paddingLevel: 'medium',
    showBorder: true,
    showShadow: false,
    unboundedWidth: true,
    role: 'combobox',
    'aria-autocomplete': 'list',
    'aria-controls': 'autocomplete-options',
    'aria-haspopup': 'listbox',
    'aria-expanded': false
  }
}));
export { AutocompleteInput as default };